import { render, staticRenderFns } from "./comWxGroupMonitorConfig.vue?vue&type=template&id=25105f6b&scoped=true"
import script from "./comWxGroupMonitorConfig.vue?vue&type=script&lang=js"
export * from "./comWxGroupMonitorConfig.vue?vue&type=script&lang=js"
import style0 from "./comWxGroupMonitorConfig.vue?vue&type=style&index=0&id=25105f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25105f6b",
  null
  
)

export default component.exports